import type { Form } from "../dynamicForm";

export const unionForms = (form: Form, other: Form): Form => {
  const questionIds = new Set(form.sections.flatMap(section => section.questionCards.map(card => card.id)));
  const sectionIds = new Set(form.sections.map(section => section.id));
  const missingCards = (section: Form["sections"][number]) =>
    section.questionCards.filter(card => !questionIds.has(card.id));

  return {
    ...form,
    sections: [
      ...form.sections.map(section => {
        const otherSection = other.sections.find(candidate => candidate.id === section.id);
        return otherSection
          ? { ...section, questionCards: [...section.questionCards, ...missingCards(otherSection)] }
          : section;
      }),
      ...other.sections
        .filter(section => !sectionIds.has(section.id))
        .map(section => ({ ...section, questionCards: missingCards(section) }))
        .filter(section => section.questionCards.length > 0),
    ],
  };
};
